<template>
  <div class="w-full fixed h-full login flex justify-center items-center mdmax:relative" :class="{ 'mdmax:h-screen': visibleState === 'forgot-password' }">
    <div class="w-7/12 bg-white h-full" v-if="!isMobile">
      <div class="polygon bg-neutral-600 h-full flex items-center flex-col justify-center gap-10">
        <div class="flex justify-center items-center pr-15p">
          <img src="@/assets/images/logos/Logo-linknau-new.svg" class="w-56" />
        </div>
        <div class="w-full pr-15p">
          <carousel :options="carouselBannerOptions" :slides="slides">
            <template slot="content" slot-scope="{ item, index }">
              <img :src="item.image" class="inline-block mb-6" :id="'image-' + index" />
              <p class="w-3/5 mx-auto text-white">{{ item.description }}</p>
            </template>
          </carousel>
        </div>
      </div>
    </div>
    <div class="w-5/12 bg-white relative h-full mdmax:w-full">
      <div class="px-36 py-20 flex flex-col justify-center h-full mdmax:px-10 mdmax:py-10">
        <div class="text-center">
          <img src="@/assets/images/logos/linknau-logo.svg" class="inline-block" />
          <p class="font-bold text-2xl mt-10 mb-14 mdmax:mt-20">Linknau for Business</p>
        </div>
        <div class="form mt-2 text-left" v-if="visibleState === 'login'">
          <div class="mb-3">
            <TextField type="text" v-model="payload.username" label="Alamat Email" placeholder="Silahkan masukan alamat email" @enter="doLogin()" :error="errors['username']" />
          </div>
          <div class="mb-3">
            <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Password</label>
            <div class="relative">
              <TextField :type="typeInput" v-model="payload.password" placeholder="Silahkan masukan password" @enter="doLogin()" @input="userIsTyping" :error="errors['password']" />
              <img src="@/assets/images/icons/open-eye.svg" v-if="typeInput === 'password' && isTyping" @click="showPassword(true)" class="w-5 absolute right-4 top-1/2 transform -translate-y-1/2" />
              <img src="@/assets/images/icons/close-eye.svg" v-if="typeInput === 'text' && isTyping" @click="showPassword(false)" class="w-5 absolute right-4 top-1/2 transform -translate-y-1/2" />
            </div>
          </div>
          <div class="flex justify-end mb-4" v-if="loginAttempts >= 3">
            <Recaptcha @success="doLogin()" />
          </div>
          <div class="flex justify-end mb-4">
            <span class="text-primary-500 font-medium cursor-pointer" @click="switchTo('forgot-password')">Lupa password?</span>
          </div>
          <div class="login__form-submit">
            <transition name="fade" mode="out-in">
              <div class="text-system-error mb-3" v-if="generalError">{{ generalError }}</div>
            </transition>
            <Button @action="doLogin()" buttonText="Login" size="full" />
          </div>
          <div class="mt-3">
            <LinkButton buttonText="Registrasi Mitra Bisnis" buttonType="dark" url="/registration" linkType="internal" size="full" />
          </div>
          <p class="mt-4 text-sm">
            Dengan melanjutkan, Anda memahami dan menyetujui penggunaan informasi yang Anda kirimkan sesuai dengan
            <a href="https://www.linknau.id/syarat-ketentuan" target="_blank" class="inline-block text-primary-700 font-semibold">Syarat & Ketentuan</a> dan
            <a href="https://www.linknau.id/kebijakan-privasi" target="_blank" class="inline-block text-primary-700 font-semibold">Kebijakan Privasi</a>.
          </p>
          <div class="mt-10 text-center">
            <!-- <a href="https://bit.ly/Regitrasi_LinknauForBusiness" target="_blank" class="text-primary-500">Registrasi Mitra Bisnis</a> -->
            
          </div>
        </div>
        <div class="text-left" v-if="visibleState === 'forgot-password'">
          <p class="text-3xl font-bold text-left mb-14">Lupa password?</p>
          <div class="mb-9">
            <TextField type="text" v-model="resetPasswordPayload.email" label="Alamat Email" placeholder="Silahkan masukan alamat email" @enter="doReset()" :error="resetError" />
          </div>
          <div class="mb-12">
            <Button @action="doReset()" :disabled="disabledReset" buttonText="Reset" size="full" />
          </div>
          <div class="flex items-center justify-center">
            <span class="text-primary-500 flex items-center gap-3 cursor-pointer font-medium" @click="switchTo('login')"><ArrowForward direction="left" color="primary-500" />Kembali ke login</span>
          </div>
        </div>
      </div>
    </div>
    <Toast />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { isNotEmptyError } from '@/util/form-validator'
import Recaptcha from '../../components/Recaptcha/Recaptcha.vue'
const CONFIG = {
  username: 'Username',
  password: 'Password',
  reset_email: 'Email'
}
export default {
  name: 'Login',
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Carousel: () => import(/* webpackChunkName: "Carousel" */ '@/components/Carousel/Carousel'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    ArrowForward: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/ArrowForward'),
    Toast: () => import(/* webpackChunkName: "Toast" */ '@/components/Toast/Toast'),
    Recaptcha: () => import(/* webpackChunkName: "Recaptcha" */ '@/components/Recaptcha/Recaptcha')
  },
  data: () => ({
    visibleState: 'login',
    typeInput: 'password',
    isTyping: false,
    resetPasswordPayload: {
      email: null
    },
    slides: [
      {
        image: require('@/assets/images/Login-1.png'),
        description: '#NgapainAjhMudah, Linknau mengintergasikan berbagai jenis logistik dan moda transportasi, sehingga memudahkan pengguna untuk mengirim barang dan jasa melalui aplikasi.'
      },
      {
        image: require('@/assets/images/Login-2.png'),
        description: '#NgapainAjhMudah, Linknau mengintergasikan berbagai jenis logistik dan moda transportasi, sehingga memudahkan pengguna untuk mengirim barang dan jasa melalui aplikasi.'
      },
      {
        image: require('@/assets/images/Login-3.png'),
        description: '#NgapainAjhMudah, Linknau mengintergasikan berbagai jenis logistik dan moda transportasi, sehingga memudahkan pengguna untuk mengirim barang dan jasa melalui aplikasi.'
      }
    ],
    payload: {
      username: null,
      password: null
    },
    errors: [],
    generalError: null,
    carouselBannerOptions: {
      rewind: true,
      arrows: false
    },
    resetError: null,
    disabledReset: false,
    loginAttempts: 0,
    showRecaptcha: false,
    captchaVerified: false
  }),
  watch: {
    'payload.password': function(val) {
      val.length > 0 ? (this.isTyping = true) : (this.isTyping = false)
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'userData']),
    ...mapGetters('common', ['isMobile'])
  },
  methods: {
    ...mapActions('auth', ['login', 'forgotPassword']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    userIsTyping(e) {
      if (e?.target?.value?.length > 0) {
        this.isTyping = true
      }
      this.isTyping = false
    },
    showPassword(status) {
      status ? (this.typeInput = 'text') : (this.typeInput = 'password')
    },
    doLogin() {
      if (this.validForm()) {
        if (this.showRecaptcha && this.captchaVerified) {
          this.generalError = 'Please verify reCAPTCHA'
          return
        }
        this.loginAttempts++
        const requestBody = {
          username: this.payload.username,
          password: this.payload.password
        }
        this.showLoading()
        this.generalError = null
        this.login({
          payloads: requestBody
        })
          .then(res => {
            this.hideLoading()
            const loginResponse = res.data.data
            if (loginResponse?.user?.require_change_password) {
              this.$router.push('/reset-password')
            } else {
              if (this.userData.user.role_type === 'EXTERNAL') {
                this.$router.push('/dashboard')
              } else {
                this.$router.push('/dashboard')
              }
            }
          })
          .catch(error => {
            this.hideLoading()
            this.generalError = error.response?.data?.message
          })
      }
    },
    validForm() {
      const error = isNotEmptyError(this.payload)
      this.errors = error.reduce(function(map, obj) {
        map[obj.field] = CONFIG[obj.field] + ' ' + obj.error
        return map
      }, {})
      return Object.keys(this.errors).length === 0
    },
    switchTo(target) {
      this.visibleState = target
      this.disabledReset = false
      this.resetError = null
    },
    doReset() {
      const error = isNotEmptyError(this.resetPasswordPayload)
      if (error.length > 0) {
        this.resetError = 'Email harus diisi!'
        return
      }
      const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      if (!regex.test(this.resetPasswordPayload.email)) {
        this.resetError = 'Email format salah!'
        return
      }
      let self = this
      this.showLoading()
      this.disabledReset = true
      this.forgotPassword({
        payloads: {
          email: this.resetPasswordPayload.email
        }
      }).then(() => {
        this.hideLoading()
        this.setToast({
          options: { type: 'success', duration: 2000, primaryText: 'Request Berhasil', secondaryText: 'Silahkan cek email Anda.', callback: this.handleCallback }
        })
      })
    },
    handleCallback() {
      this.switchTo('login')
    }
  }
}
</script>
<style lang="scss" scoped>
.login-form {
  max-width: 490px;
  margin: 0 auto;
}
.polygon {
  clip-path: polygon(85% 0, 100% 50%, 85% 100%, 0 100%, 0 0);
  height: 100%;
  width: 100%;
}
.pr-15p {
  padding-right: 15%;
}
</style>
